import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { attr } from '@ember-data/model';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16;
let ApplicationModel = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = attr('string'), _dec5 = attr('string'), _dec6 = attr('string'), _dec7 = attr('string'), _dec8 = attr('string'), _dec9 = attr('string'), _dec0 = attr('string'), _dec1 = attr('string'), _dec10 = attr('string'), _dec11 = attr('string'), _dec12 = attr('string'), _dec13 = attr('string'), _dec14 = attr('string'), _dec15 = attr('string'), _dec16 = attr('boolean', {
  defaultValue: false
}), _class = class ApplicationModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "contact_view", _descriptor, this);
    _initializerDefineProperty(this, "contact_edit", _descriptor2, this);
    _initializerDefineProperty(this, "product_view", _descriptor3, this);
    _initializerDefineProperty(this, "product_edit", _descriptor4, this);
    _initializerDefineProperty(this, "project_view", _descriptor5, this);
    _initializerDefineProperty(this, "project_edit", _descriptor6, this);
    _initializerDefineProperty(this, "event_view", _descriptor7, this);
    _initializerDefineProperty(this, "event_edit", _descriptor8, this);
    _initializerDefineProperty(this, "workhour_view", _descriptor9, this);
    _initializerDefineProperty(this, "workhour_edit", _descriptor0, this);
    _initializerDefineProperty(this, "invoice_view", _descriptor1, this);
    _initializerDefineProperty(this, "invoice_edit", _descriptor10, this);
    _initializerDefineProperty(this, "expense_view", _descriptor11, this);
    _initializerDefineProperty(this, "expense_edit", _descriptor12, this);
    _initializerDefineProperty(this, "payment_view", _descriptor13, this);
    _initializerDefineProperty(this, "payment_edit", _descriptor14, this);
    _initializerDefineProperty(this, "dashboard_view", _descriptor15, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor16, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "contact_view", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "contact_edit", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "product_view", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "product_edit", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "project_view", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "project_edit", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "event_view", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "event_edit", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "workhour_view", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "workhour_edit", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "invoice_view", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "invoice_edit", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "expense_view", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "expense_edit", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "payment_view", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "payment_edit", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "dashboard_view", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { ApplicationModel as default };
//# sourceMappingURL=application.js.map
